import React, { useEffect, useState } from 'react';
import api from '../api';
import AdCard from '../components/AdCard';
import Seo from '../components/Seo';
import { getRecentlyViewedIds, RETENTION_DAYS } from '../utils/recentlyViewed';
import '../components/AdsGrid.css';

// Full recently-viewed history (up to RETENTION_DAYS old), reuses AdsGrid's grid layout/classes.
const RecentlyViewedPage = () => {
    const [ads, setAds] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const ids = getRecentlyViewedIds();
        if (ids.length === 0) { setAds([]); setLoading(false); return; }

        api.get('/ads/by-ids', { params: { ids: ids.join(',') } })
            .then(({ data }) => {
                const byId = new Map(data.map(ad => [ad.id, ad]));
                setAds(ids.map(id => byId.get(id)).filter(Boolean));
            })
            .catch(() => setAds([]))
            .finally(() => setLoading(false));
    }, []);

    return (
        <>
            <Seo
                title="Недавно просмотренные"
                description={`Объявления, которые вы просматривали за последние ${RETENTION_DAYS} дней.`}
            />
            <div className="listings-grid">
                <h2 className="listings-grid__title">Недавно просмотренные</h2>
                {loading
                    ? <div className="listings-grid__loading">Загрузка...</div>
                    : ads.length === 0
                        ? <div className="listings-grid__empty">Здесь пока пусто</div>
                        : (
                            <div className="listings-grid__list">
                                {ads.map(ad => (
                                    <AdCard
                                        key={ad.id}
                                        ad={ad}
                                        view="grid"
                                        listName="recently_viewed_page"
                                        onHidden={(hiddenAd, payload) => {
                                            if (payload.sellerId) {
                                                setAds(prev => prev.filter(a => a.userId !== payload.sellerId));
                                            } else {
                                                setAds(prev => prev.filter(a => a.id !== payload.adId));
                                            }
                                        }}
                                    />
                                ))}
                            </div>
                        )
                }
            </div>
        </>
    );
};

export default RecentlyViewedPage;
